import React from 'react';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h2 className="not-found-header">Page Not Found</h2>
      <p className="not-found-message">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
    </div>
  )
}

export default NotFound;